export default {
  props: {
    photo: {
      type: Object,
    },

    logo: {
      type: Object,
    },

    title: {
      type: String,
    },

    description: {
      type: String,
    },

    buttons: {
      type: Array,
    },
  },
}
